// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/iam/v1/service.proto (package annealing.iam.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { IdentityProvider, IdentityProviderSchema, RoleBinding, RoleBindingSchema, ServiceAccount, ServiceAccountSchema } from "./resources_pb";
import { file_annealing_iam_v1_resources } from "./resources_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file annealing/iam/v1/service.proto.
 */
export const file_annealing_iam_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_annealing_iam_v1_resources]);

/**
 * @generated from message annealing.iam.v1.ListIdentityProvidersRequest
 */
export type ListIdentityProvidersRequest = Message<"annealing.iam.v1.ListIdentityProvidersRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.iam.v1.ListIdentityProvidersRequest.
 * Use `create(ListIdentityProvidersRequestSchema)` to create a new message.
 */
export const ListIdentityProvidersRequestSchema: GenMessage<ListIdentityProvidersRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 0);

/**
 * @generated from message annealing.iam.v1.ListIdentityProvidersResponse
 */
export type ListIdentityProvidersResponse = Message<"annealing.iam.v1.ListIdentityProvidersResponse"> & {
  /**
   * @generated from field: repeated annealing.iam.v1.IdentityProvider identity_providers = 1;
   */
  identityProviders: IdentityProvider[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.iam.v1.ListIdentityProvidersResponse.
 * Use `create(ListIdentityProvidersResponseSchema)` to create a new message.
 */
export const ListIdentityProvidersResponseSchema: GenMessage<ListIdentityProvidersResponse> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 1);

/**
 * @generated from message annealing.iam.v1.GetIdentityProviderRequest
 */
export type GetIdentityProviderRequest = Message<"annealing.iam.v1.GetIdentityProviderRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.GetIdentityProviderRequest.
 * Use `create(GetIdentityProviderRequestSchema)` to create a new message.
 */
export const GetIdentityProviderRequestSchema: GenMessage<GetIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 2);

/**
 * @generated from message annealing.iam.v1.CreateIdentityProviderRequest
 */
export type CreateIdentityProviderRequest = Message<"annealing.iam.v1.CreateIdentityProviderRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.iam.v1.IdentityProvider identity_provider = 2;
   */
  identityProvider?: IdentityProvider;

  /**
   * @generated from field: string identity_provider_id = 3;
   */
  identityProviderId: string;
};

/**
 * Describes the message annealing.iam.v1.CreateIdentityProviderRequest.
 * Use `create(CreateIdentityProviderRequestSchema)` to create a new message.
 */
export const CreateIdentityProviderRequestSchema: GenMessage<CreateIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 3);

/**
 * @generated from message annealing.iam.v1.DeleteIdentityProviderRequest
 */
export type DeleteIdentityProviderRequest = Message<"annealing.iam.v1.DeleteIdentityProviderRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.DeleteIdentityProviderRequest.
 * Use `create(DeleteIdentityProviderRequestSchema)` to create a new message.
 */
export const DeleteIdentityProviderRequestSchema: GenMessage<DeleteIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 4);

/**
 * @generated from message annealing.iam.v1.ListRoleBindingsRequest
 */
export type ListRoleBindingsRequest = Message<"annealing.iam.v1.ListRoleBindingsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.iam.v1.ListRoleBindingsRequest.
 * Use `create(ListRoleBindingsRequestSchema)` to create a new message.
 */
export const ListRoleBindingsRequestSchema: GenMessage<ListRoleBindingsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 5);

/**
 * @generated from message annealing.iam.v1.ListRoleBindingsResponse
 */
export type ListRoleBindingsResponse = Message<"annealing.iam.v1.ListRoleBindingsResponse"> & {
  /**
   * @generated from field: repeated annealing.iam.v1.RoleBinding role_bindings = 1;
   */
  roleBindings: RoleBinding[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.iam.v1.ListRoleBindingsResponse.
 * Use `create(ListRoleBindingsResponseSchema)` to create a new message.
 */
export const ListRoleBindingsResponseSchema: GenMessage<ListRoleBindingsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 6);

/**
 * @generated from message annealing.iam.v1.GetRoleBindingRequest
 */
export type GetRoleBindingRequest = Message<"annealing.iam.v1.GetRoleBindingRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.GetRoleBindingRequest.
 * Use `create(GetRoleBindingRequestSchema)` to create a new message.
 */
export const GetRoleBindingRequestSchema: GenMessage<GetRoleBindingRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 7);

/**
 * @generated from message annealing.iam.v1.CreateRoleBindingRequest
 */
export type CreateRoleBindingRequest = Message<"annealing.iam.v1.CreateRoleBindingRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.iam.v1.RoleBinding role_binding = 2;
   */
  roleBinding?: RoleBinding;

  /**
   * @generated from field: string role_binding_id = 3;
   */
  roleBindingId: string;
};

/**
 * Describes the message annealing.iam.v1.CreateRoleBindingRequest.
 * Use `create(CreateRoleBindingRequestSchema)` to create a new message.
 */
export const CreateRoleBindingRequestSchema: GenMessage<CreateRoleBindingRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 8);

/**
 * @generated from message annealing.iam.v1.DeleteRoleBindingRequest
 */
export type DeleteRoleBindingRequest = Message<"annealing.iam.v1.DeleteRoleBindingRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.DeleteRoleBindingRequest.
 * Use `create(DeleteRoleBindingRequestSchema)` to create a new message.
 */
export const DeleteRoleBindingRequestSchema: GenMessage<DeleteRoleBindingRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 9);

/**
 * @generated from message annealing.iam.v1.ListServiceAccountsRequest
 */
export type ListServiceAccountsRequest = Message<"annealing.iam.v1.ListServiceAccountsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.iam.v1.ListServiceAccountsRequest.
 * Use `create(ListServiceAccountsRequestSchema)` to create a new message.
 */
export const ListServiceAccountsRequestSchema: GenMessage<ListServiceAccountsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 10);

/**
 * @generated from message annealing.iam.v1.ListServiceAccountsResponse
 */
export type ListServiceAccountsResponse = Message<"annealing.iam.v1.ListServiceAccountsResponse"> & {
  /**
   * @generated from field: repeated annealing.iam.v1.ServiceAccount service_accounts = 1;
   */
  serviceAccounts: ServiceAccount[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.iam.v1.ListServiceAccountsResponse.
 * Use `create(ListServiceAccountsResponseSchema)` to create a new message.
 */
export const ListServiceAccountsResponseSchema: GenMessage<ListServiceAccountsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 11);

/**
 * @generated from message annealing.iam.v1.GetServiceAccountRequest
 */
export type GetServiceAccountRequest = Message<"annealing.iam.v1.GetServiceAccountRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.GetServiceAccountRequest.
 * Use `create(GetServiceAccountRequestSchema)` to create a new message.
 */
export const GetServiceAccountRequestSchema: GenMessage<GetServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 12);

/**
 * @generated from message annealing.iam.v1.CreateServiceAccountRequest
 */
export type CreateServiceAccountRequest = Message<"annealing.iam.v1.CreateServiceAccountRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.iam.v1.ServiceAccount service_account = 2;
   */
  serviceAccount?: ServiceAccount;

  /**
   * @generated from field: string service_account_id = 3;
   */
  serviceAccountId: string;
};

/**
 * Describes the message annealing.iam.v1.CreateServiceAccountRequest.
 * Use `create(CreateServiceAccountRequestSchema)` to create a new message.
 */
export const CreateServiceAccountRequestSchema: GenMessage<CreateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 13);

/**
 * @generated from message annealing.iam.v1.DeleteServiceAccountRequest
 */
export type DeleteServiceAccountRequest = Message<"annealing.iam.v1.DeleteServiceAccountRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.iam.v1.DeleteServiceAccountRequest.
 * Use `create(DeleteServiceAccountRequestSchema)` to create a new message.
 */
export const DeleteServiceAccountRequestSchema: GenMessage<DeleteServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_annealing_iam_v1_service, 14);

/**
 * @generated from service annealing.iam.v1.IamService
 */
export const IamService: GenService<{
  /**
   * @generated from rpc annealing.iam.v1.IamService.GetIdentityProvider
   */
  getIdentityProvider: {
    methodKind: "unary";
    input: typeof GetIdentityProviderRequestSchema;
    output: typeof IdentityProviderSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.ListIdentityProviders
   */
  listIdentityProviders: {
    methodKind: "unary";
    input: typeof ListIdentityProvidersRequestSchema;
    output: typeof ListIdentityProvidersResponseSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.CreateIdentityProvider
   */
  createIdentityProvider: {
    methodKind: "unary";
    input: typeof CreateIdentityProviderRequestSchema;
    output: typeof IdentityProviderSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.DeleteIdentityProvider
   */
  deleteIdentityProvider: {
    methodKind: "unary";
    input: typeof DeleteIdentityProviderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.GetRoleBinding
   */
  getRoleBinding: {
    methodKind: "unary";
    input: typeof GetRoleBindingRequestSchema;
    output: typeof RoleBindingSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.ListRoleBindings
   */
  listRoleBindings: {
    methodKind: "unary";
    input: typeof ListRoleBindingsRequestSchema;
    output: typeof ListRoleBindingsResponseSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.CreateRoleBinding
   */
  createRoleBinding: {
    methodKind: "unary";
    input: typeof CreateRoleBindingRequestSchema;
    output: typeof RoleBindingSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.DeleteRoleBinding
   */
  deleteRoleBinding: {
    methodKind: "unary";
    input: typeof DeleteRoleBindingRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.GetServiceAccount
   */
  getServiceAccount: {
    methodKind: "unary";
    input: typeof GetServiceAccountRequestSchema;
    output: typeof ServiceAccountSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.ListServiceAccounts
   */
  listServiceAccounts: {
    methodKind: "unary";
    input: typeof ListServiceAccountsRequestSchema;
    output: typeof ListServiceAccountsResponseSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.CreateServiceAccount
   */
  createServiceAccount: {
    methodKind: "unary";
    input: typeof CreateServiceAccountRequestSchema;
    output: typeof ServiceAccountSchema;
  },
  /**
   * @generated from rpc annealing.iam.v1.IamService.DeleteServiceAccount
   */
  deleteServiceAccount: {
    methodKind: "unary";
    input: typeof DeleteServiceAccountRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_annealing_iam_v1_service, 0);

